import { Box, Flex, Container } from '@podiumhq/design-system';

import { WiggleAnimation } from 'styles';

import SelectPlanGhostStateCard from './SelectPlanGhostStateCard';

const SelectPlanLoadingGhostView = ({ isDormant, isMobile }) => (
  <WiggleAnimation data-testid="select-plan-loading-ghost-view">
    <Box
      margin={isDormant ? '0' : '0 auto'}
      maxWidth="1440px"
      padding={isMobile ? '24px' : isDormant ? '0' : '20px 40px 24px 40px'}
    >
      <Container maxW="container.xl">
        {!isDormant && (
          <SelectPlanGhostStateCard
            height="72px"
            marginTop="0"
            width={isMobile ? '100%' : '490px'}
          />
        )}

        <Flex
          align={isMobile ? 'center' : 'flex-end'}
          boxSizing="border-box"
          direction={isMobile ? 'column' : 'row'}
          justify="space-between"
          maxWidth="100%"
        >
          <SelectPlanGhostStateCard isMobile={isMobile} />
          <SelectPlanGhostStateCard isMobile={isMobile} />
          <SelectPlanGhostStateCard isMobile={isMobile} />
        </Flex>

        <SelectPlanGhostStateCard {...ghostButtonStyles} />
      </Container>
    </Box>
  </WiggleAnimation>
);

const ghostButtonStyles = {
  height: 40,
  margin: '46px auto 0 auto',
  width: 281,
};

export default SelectPlanLoadingGhostView;
